<template lang="pug">
</template>

<script lang="ts">
import Vue from 'vue';

// Components

// Helpers
import { getCookie, updateCookies } from '@/helpers/cookie';

export default Vue.extend({
    data() {
        return {
            selectedImageElement: null
        }
    },
    methods: {
        handleImageClick(event) {
            if (event.target.classList.contains('v-responsive__content')) {
                // Look for sibling v-image__image div under the common v-image parent
                const vImageParent = event.target.closest('.v-image');
                if (vImageParent && (!this.onlySelectable || vImageParent.classList.contains('selectable'))) {
                    const imageDiv = vImageParent.querySelector('div.v-image__image');
                    if (imageDiv) {
                        // Remove highlight from previously selected image
                        if (this.selectedImageElement) {
                            this.selectedImageElement.classList.remove('media-selected');
                        }

                        // Store and highlight the new selected image
                        this.selectedImageElement = imageDiv;
                        imageDiv.classList.add('media-selected');
                    }
                }
            } else {
                if (this.selectedImageElement) {
                    this.selectedImageElement.classList.remove('media-selected');
                }

                this.selectedImageElement = null;
            }
        },

        handleKeyDown(event) {
            if (event.metaKey || event.ctrlKey) {
                if (event.key === 'c') {
                    // Extract image data from the selected element
                    const backgroundImage = this.selectedImageElement.style.backgroundImage;
                    const imageUrl = backgroundImage.replace(/^url\(["']?/, '').replace(/["']?\)$/, '');

                    const imageData = {
                        url: imageUrl,
                        timestamp: new Date().toISOString(),
                    };

                    const settingsObject = {
                        copiedImageData: JSON.stringify(imageData)
                    };

                    const settingsHelperMap = [{
                        cookieKey: 'copied_image_data',
                        varKey: 'copiedImageData',
                    }];

                    updateCookies(settingsObject, settingsHelperMap, "3600"); // 1 hour
                    this.showSnackbar('info', 'Successfully Copied Image');

                } else if (event.key === 'v' && !this.isInTextSelection() && this.onPaste !== null) {
                    const copiedImageData = getCookie('copied_image_data');
                    if (copiedImageData) {
                        const imageData = JSON.parse(copiedImageData);
                        this.onPaste(imageData.url);
                        this.showSnackbar('info', 'Successfully Pasted Image');
                    }
                }
            }
        },
        isInTextSelection() {
            // Check if the currently focused element is a text input
            const activeElement = document.activeElement as HTMLElement;
            const isTextInput = activeElement && (
                activeElement.tagName === 'INPUT' ||
                activeElement.tagName === 'TEXTAREA' ||
                activeElement.contentEditable === 'true' ||
                activeElement.isContentEditable
            );

            // Check if there's an active text selection
            const hasTextSelection = window.getSelection &&
                window.getSelection()?.toString()?.length > 0;

            return isTextInput || hasTextSelection;
        },
    },
    computed: {

    },
    components: {

    },
    props: {
        onPaste: {
            type: Function,
            required: false,
            default: null,
        },
        onlySelectable: {
            type: Boolean,
            required: false,
            default: false,
        },
        showSnackbar: {
            type: Function,
            required: true,
        },
    },
    watch: {

    },
    created() {
    },
    destroyed() {
        document.removeEventListener('click', this.handleImageClick);
        document.removeEventListener('keydown', this.handleKeyDown);
    },
    mounted() {
        document.addEventListener('click', this.handleImageClick);
        document.addEventListener('keydown', this.handleKeyDown);
    },
})
</script>

<style lang="scss">
.media-selected {
    border: 2px solid var(--volie-blue) !important;
    border-radius: 4px;
    // transition: all 0.3s ease !important;
}
</style>